import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { AccordionSummary, Grid, IconButton, Typography } from "@mui/material";
import { grey } from "@mui/material/colors";

export function ClientPassportAccordionHeader({
    title,
    onClick,
    showAddButton = true,
    onAddClick,
    additionalContent,
    disableAddButton = false,
}) {
    return (
        <AccordionSummary
            expandIcon={
                <ExpandMoreIcon
                    sx={{
                        "&:hover": {
                            backgroundColor: grey[200],
                            borderRadius: 999,
                        },
                    }}
                />
            }
            sx={{ height: 0 }}
            onClick={onClick}
        >
            <Grid
                container
                direction="row"
                sx={{
                    alignItems: "center",
                    cursor: "default",
                }}
                columnGap={1}
                onClick={(e) => e.stopPropagation()}
            >
                <Typography variant="h6">{title}</Typography>
                {showAddButton && (
                    <IconButton color="success" onClick={onAddClick} disabled={disableAddButton}>
                        <AddCircleOutlineIcon />
                    </IconButton>
                )}
                {additionalContent}
            </Grid>
        </AccordionSummary>
    );
}
